import { render, staticRenderFns } from "./OnboardingChooseUserModal.vue?vue&type=template&id=67dcceac&scoped=true"
import script from "./OnboardingChooseUserModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseUserModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseUserModal.vue?vue&type=style&index=0&id=67dcceac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcceac",
  null
  
)

export default component.exports